import Services from '../Service'

class ItemService extends Services {
  constructor() {
    super()
    this.resource = 'itens'
  }

  async getItens(params) {
    return await this.getAPI(this.resource, params)
  }

  async getFiltros(){
    return await this.getAPI(`${this.resource}/filtros`)
  }

  async getItemImages(id) {
    return await this.getAPI(`${this.resource}/${id}/imagens`)
  }

  async getBarcodes(params) {
    return await this.getAPI(`${this.resource}/codigos-barras`, params)
  }

  // PDF de etiquetas (#67): o corpo é o PDF, a parte seguinte e os itens
  // pulados vêm nos cabeçalhos — por isso devolve a resposta inteira.
  async getBarcodeLabelsPdf(params) {
    return await this._http.get(`${this.resource}/codigos-barras/pdf`, {
      params,
      responseType: 'blob',
    })
  }

  async generatePdf(params) {
    const requestUrl = `${this.resource}/generate-pdf`
    const response = await this._http.get(requestUrl, {
      params,
      responseType: 'blob',
    })
    return response
  }
}

export default new ItemService()
